module.exports = __webpack_public_path__ + "assets/images/vcr_gym-03.22b9b48afd127da1a0a15fcecb9a8719.svg";